// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__1nIIg","content":"About_content__pGhsx","subsection":"About_subsection__Dn1xo","opentime":"About_opentime__Up8vq"};